// ============================================
// Manor Miser - Game Constants
// ============================================

/** Duration of the betting phase in seconds */
export const BETTING_DURATION = 15;

/** Starting coins for each player */
export const STARTING_MONEY = 100;

/** Minimum number of players to start a game */
export const MIN_PLAYERS = 2;

/** Maximum number of players in a room */
export const MAX_PLAYERS = 8;

/** Available bet increments */
export const BET_INCREMENTS = [1, 5, 10] as const;

// -----------------------------
// Timing Constants
// -----------------------------

/** Duration of reveal phase in milliseconds */
export const REVEAL_DURATION = 4000;

/** Duration of elimination phase in milliseconds */
export const ELIMINATION_DURATION = 3000;

/** Duration before transitioning to next round in milliseconds */
export const NEXT_ROUND_DELAY = 2000;

// -----------------------------
// Single Player Constants
// -----------------------------

/** Medieval-themed bot names → allowed character sprite types */
export const BOT_NAMES = {
  'Sir Reginald': ['warrior', 'wizard'],
  'Friar Tuck': ['farmer', 'commoner'],
  'Baron Mortimer': ['warrior', 'wizard', 'commoner'],
  'Lord Cedric': ['warrior', 'wizard', 'commoner'],
  'Duke Alaric': ['warrior', 'wizard', 'commoner'],
  'Knight Percival': ['warrior'],
  'Squire Oswald': ['warrior', 'commoner', 'farmer'],
  'Dame Isolde': ['female'],
  'Sister Agnes': ['female'],
  'Maiden Rowena': ['female'],
  'Lady Beatrice': ['female'],
  'Countess Elara': ['female'],
  'Sir William Marshal': ['warrior'],
  'Friar Roger Bacon': ['farmer', 'commoner'],
  'Brother Caedmon': ['farmer', 'commoner'],
  'Meister Eckhart': ['wizard', 'commoner'],
  'Dame Christine': ['female'],
  'Abbess Hildegard': ['female'],
  'Dame Julian': ['female'],
  'Marco Polo': ['commoner', 'farmer'],
  'Jacques Coeur': ['commoner', 'farmer'],
  'Master Villard': ['commoner', 'farmer'],
} as const;

/** List of bot names (derived from BOT_NAMES keys) */
export const BOT_NAME_LIST = Object.keys(BOT_NAMES) as (keyof typeof BOT_NAMES)[];

/** Minimum number of bots in single player */
export const MIN_BOTS = 2;

/** Maximum number of bots in single player */
export const MAX_BOTS = 7;
